// console.log('key variants', '{{item.key }}');

document.addEventListener("DOMContentLoaded", () => {
    let cartData = [];
    let cartItemsData = JSON.parse(localStorage.getItem("cart_products"));
    fetch("/cart.js", {
        method: "GET"
    }).then(res => res.json()).then((res) => {
        cartData = res.items.map(item => {
            return {
                properties: item.properties,
                quantity: item.quantity,
                originOptions: item.options_with_values,
                key: item.key,
                variantId: item.variant_id,
                productId: item.product_id
            }
        });
    })

    const changeBtnText = (target, isLoadding) => {
        const svg = `<svg width="5%" height="5%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-double-ring"><circle cx="50" cy="50" ng-attr-r="{{config.radius}}" ng-attr-stroke-width="{{config.width}}" ng-attr-stroke="{{config.c1}}" ng-attr-stroke-dasharray="{{config.dasharray}}" fill="none" stroke-linecap="round" r="40" stroke-width="4" stroke="#000000" stroke-dasharray="62.83185307179586 62.83185307179586" transform="rotate(287.873 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle><circle cx="50" cy="50" ng-attr-r="{{config.radius2}}" ng-attr-stroke-width="{{config.width}}" ng-attr-stroke="{{config.c2}}" ng-attr-stroke-dasharray="{{config.dasharray2}}" ng-attr-stroke-dashoffset="{{config.dashoffset2}}" fill="none" stroke-linecap="round" r="35" stroke-width="4" stroke="#9f9f9f" stroke-dasharray="54.97787143782138 54.97787143782138" stroke-dashoffset="54.97787143782138" transform="rotate(-287.873 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;-360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg>`;
        const el = `<span class="text">Update Cart</span>`
        if (isLoadding) {
            target.innerHTML = svg;
        } else {
            target.innerHTML = el;
        }

        target.closest("li").querySelectorAll(".size-data,.variant-options").forEach(el => {
            el.classList.add("hide");
            el.nextElementSibling.querySelector("span").innerHTML = el.value;
        })
        target.closest("li").querySelectorAll(".static-value").forEach(el => {
            el.classList.remove("hide");
        })
    }

    function clickEvent(e) {
        e.preventDefault();
        let key = this.closest('li')?.querySelector(".data-el").getAttribute("key");
        // 定义是否改变
        let isChange = false;
        let variantChange = false;
        let currentOptionDatas = [];
        let targetImgWrapperEl = this.closest('li').querySelector(".product-img");
      
        this.closest('li')?.querySelectorAll(".variant-options").forEach(item => {
            currentOptionDatas.push(item.value);
        });
        // 本次操作item的过滤后的数据
        let thisItemData = cartData.find(item => item.key === key);
      
        // 找出已选商品的对应变体ID
        // 当前操作所对应地产品信息
        let targetProduct = cartItemsData.find(item => item.id === thisItemData.productId)
        // 获取目前改变信息所对应的变体ID
        let targetVariantId = null;
        let tempString = currentOptionDatas.sort().join("||");
        let tempImageSrc = "";
        targetProduct.variants.forEach(variant => {
            if (variant.options.sort().join("||") === tempString) {
                targetVariantId = variant.id;
                tempImageSrc = variant.featured_image?.src;
            }
        })
        // 当前改变的属性值
        let currentPropertyValue = this.closest('li')?.querySelector(".size-data")?.value;
        // 查看是变体和属性否有所改变
        if (targetVariantId !== thisItemData.variantId) {
            isChange = true;
            variantChange = true
        }
        if (currentPropertyValue !== thisItemData.properties["Size"]) {
            isChange = true;
        }
        // 查看数量是否有改变
        let currentNum = this.closest('li')?.querySelector(".qty").value;
        if (String(currentNum) != String(thisItemData.quantity)) {
            isChange = true;
        }

        // 改变图片的函数
        const changeImage = () => {
            if (targetImgWrapperEl && tempImageSrc) {
                let tempImgEl = document.createElement("img");
                tempImgEl.src = tempImageSrc;
                let removingEl = targetImgWrapperEl.querySelector("img");
                targetImgWrapperEl.removeChild(removingEl);
                targetImgWrapperEl.appendChild(tempImgEl);
            }
        }

        // 如果有改变，则更新
        if (variantChange) {
            changeBtnText(this, true);
            // 先移除该变体
            fetch("/cart/change.js", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: thisItemData.key,
                    quantity: 0
                })
            }).then(res => res.json()).then(res => {
                let formData = {
                    'items': [{
                        'id': targetVariantId,
                        'quantity': Number(currentNum),
                        'properties': {
                            ...thisItemData.properties,
                            "Size": currentPropertyValue
                        }
                    }]
                };
                fetch("/cart/add.js", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                }).then(res => res.json()).then(res => {
                    changeImage();
                    alert('Update Cart Successfully!');

                }).catch((err) => {
                    console.log(err);
                    alert('Failed to update shopping cart. Please refresh and try again.')
                })
            }).finally(() => {
                changeBtnText(this, false);
            })
        } else {
            if (isChange) {
                changeBtnText(this, true);
                fetch("/cart/change.js", {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id: thisItemData.key,
                        quantity: Number(currentNum),
                        properties: {
                            ...thisItemData.properties,
                            "Size": currentPropertyValue
                        }
                    })
                }).then(res => res.json()).then(res => {
                    changeImage();
                    alert('Update Cart Successfully!');
                
                          var isChecked = $('#worry-free-checkbox').is(':checked');
                          
                          if (isChecked) { 
                              $('#worry-free-checkbox').trigger('click');
                          }
                 

                     async function getCart() {
                        try {
                          let response = await fetch('/cart.js');
                          let cart = await response.json();
                          console.log("Cart Data:", response);
                         
                         
                        let cartItems = cart.items.map(item => {
                        let productTitle = item.title;
                        productTitle = productTitle.replace(/ - USD\d+(\.\d{2})?/, '');
                        console.log('Cleaned productTitle:', productTitle);
                        const variantId_pro = item.variant_id;
                           const variantId_key = item.key;
                            if (productTitle === 'Worry Free Purchase Service') {
                              console.log('Matched variantId:',variantId_pro);
                              console.log('Matched key:',item.key);

                              jQuery.post('/cart/change.js', { id: item.key , quantity: 0})
                                  .done(function(data) {
                                    console.log(data);
                                      // location.reload();
                                  // window.location.href = window.location.href;
                                 var jsonval = $.parseJSON(data);
                                });
                            
                             $('.product_remove').each(function() {
                              if ($(this).find('.product-details .product-name').text().includes('Worry Free Purchase Service')) {
                                $(this).remove(); 
                              }
                            });
                             $('.product_remove').each(function() {
                              // Check if the product name contains "Worry Free Purchase Service"
                              if ($(this).find('.product-details .product-name').text().includes('Worry Free Purchase Service')) {
                                
                                // Check if the "Update Cart" button exists within the current product
                                if ($(this).find('.group-action .update').length === 0) {
                                  // If the "Update Cart" button is not found, remove the <li> element
                                  $(this).remove();
                                }
                              }
                            });

                            }
                          });
                          return cart;
                          
                        } catch (error) {
                          console.error("Error fetching cart:", error);
                          return null;
                        }
                      }
                                                
                     async function calculateInsuranceVariant() {
                        let cart = await getCart();
                        if (!cart || !window.insuranceProduct) return null;
                    
                        let subtotalWithoutInsurance = cart.items.reduce((total, item) => {
                          return item.product_id !== window.insuranceProduct.id ? total + item.final_line_price : total;
                        }, 0);
                    
                        let insurancePrice = Math.round(subtotalWithoutInsurance * 0.02);
                        console.log("Calculated Insurance Price:", insurancePrice);
                    
                        let insuranceVariants = window.insuranceProduct.variants;
                        if (!insuranceVariants || insuranceVariants.length === 0) {
                          console.error("No insurance variants found.");
                          return null;
                        }
                    
                        let bestVariant = insuranceVariants.reduce((closest, variant) => {
                          return Math.abs(variant.price - insurancePrice) < Math.abs(closest.price - insurancePrice) ? variant : closest;
                        }, insuranceVariants[0]);
                    
                        console.log("Best Variant Selected:", bestVariant.id);
                        return bestVariant.id;
                      }
                    
                      calculateInsuranceVariant().then(variantId => {
                        if (variantId) {
                          $.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            data: JSON.stringify({ id: variantId, quantity: 1 }),
                            dataType: 'json',
                            contentType: 'application/json',
                            success: function (response) {
                              console.log("Insurance product added:", response);
                              // setTimeout(function() {
                               // location.reload();
                                  // window.location.href = window.location.href;
                                // }, 50);
                                var isChecked_not = $('#worry-free-checkbox').is(':checked');
                        
                          
                          if (isChecked_not) { 
                            // setTimeout(function() {
                              $('#worry-free-checkbox').trigger('click');
                            // }, 50);
                          }else{
                            $('#worry-free-checkbox').trigger('click');
                          }
                            },
                            error: function (xhr, status, error) {
                              console.error("Error adding insurance product:", xhr.responseText);
                            }
                          });
                        }
                      });
                    
                }).finally(() => {
                    changeBtnText(this, false);
                })
            } else {
                alert("Nothing changed~");
            }

        }
    }
    // 点击更新按钮事件
    document.querySelectorAll(".group-action div.update.btn").forEach(item => {
        item.addEventListener("click", clickEvent)
    })
    // setInterval(() => {
    //     document.querySelectorAll(".group-action div.update.btn").forEach(item => {
           
    //     })
    // })
    // note 失焦事件
    // 获取 textarea 元素
    const textarea = document.getElementById('cartSpecialInstructions');

    // 设置失去焦点事件
    textarea.addEventListener('blur', function () {
        const noteValue = textarea.value.trim();
        fetch("/cart/update.js", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                note: noteValue
            })
        }).then(res => res.json()).then(() => {
            alert("Update Note Successfully!")
        }).catch(() => {
            alert("Shopping cart note update failed. Please refresh and try again.")
        })
    });

    // 铅笔icon点击事件
    document.querySelectorAll("span.edit-icon").forEach(item => {
        item.addEventListener("click", function (e) {
            this.closest("li").querySelectorAll(".size-data,.variant-options").forEach(el => {
                el.classList.remove("hide");
            })
            this.closest("li").querySelectorAll(".static-value").forEach(el => {
                el.classList.add("hide");
            })
        })
    })
})